var i=function(i){return i.TaxCode="taxCode",i.Eic="eic",i.EicGasSupplyStation="eicGasDistributionStation",i}({});export{i as Code};
//# sourceMappingURL=validateCodeFn.js.map